import { FC, useEffect, useState } from 'react';
import Modal from '@/components/Modal/Modal';
import TransactionsTable from '@/features/user-profile/components/TransactionsTable';
import { SortTransaction, Transaction } from '@/services/transactions/TransactionTypes';
import useGetTransactions from '@/services/transactions/queries/useGetTransactions';
import { SortingState, Updater } from '@tanstack/react-table';
import Paginator from '@/components/Paginator/Paginator';
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner';

const LIMIT = 10;
const DEFAULT_SORT: SortTransaction = { field: 'createdAt', order: 'desc' };

interface TransactionsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
const TransactionsModal: FC<TransactionsModalProps> = ({ isOpen, onClose }) => {
  const [pageNumber, setPageNumber] = useState(0);
  const [sort, setSort] = useState<SortTransaction>(DEFAULT_SORT);
  const {
    data: transactionsData,
    isLoading,
    refetch,
  } = useGetTransactions({
    skip: pageNumber * LIMIT,
    take: LIMIT,
    sort,
  });
  // const { walletAddress } = useWalletAddress();

  // const [selectedWallet, setSelectedWallet] = useState(
  //   formatWalletAddress(walletAddress),
  // );

  const handlerSortingChange = (updaterOrValue: Updater<SortingState>) => {
    const applySorting = (currentSorting: SortingState): SortingState => {
      return typeof updaterOrValue === 'function' ? updaterOrValue(currentSorting) : updaterOrValue;
    };

    const newSorting = applySorting([]);

    if (Array.isArray(newSorting)) {
      newSorting.forEach(({ id, desc }) => {
        setSort({ field: id, order: desc ? 'desc' : 'asc' } as SortTransaction);
      });
    }
  };

  useEffect(() => {
    refetch();
  }, [pageNumber, sort]);

  const onPageNumberChange = (newValue: number) => setPageNumber(newValue - 1);

  return (
    <Modal
      open={isOpen}
      setClose={onClose}
      titleComponent={<Modal.Title onClose={onClose} title="Transaction History" />}
    >
      <div className="flex flex-col justify-center gap-5 md:min-h-[42em] md:min-w-[53.75em]">
        {/*This filter is going to be release later*/}
        {/*<div className="flex flex-col gap-3">*/}
        {/*  <div className="flex gap-1 text-white items-center">*/}
        {/*    <LiaWalletSolid className="w-5 h-5" />*/}
        {/*    <span>Wallet:</span>*/}
        {/*    <div className="ml-2">*/}
        {/*      {isLoadingWallet ? (*/}
        {/*        <LoadingSpinner />*/}
        {/*      ) : (*/}
        {/*        <Select*/}
        {/*          defaultSelectedLabelKey={selectedWallet}*/}
        {/*          fullWidth*/}
        {/*          options={[selectedWallet]} */}
        {/*          onChange={(value) => {*/}
        {/*            setSelectedWallet(value);*/}
        {/*          }}*/}
        {/*          placeholder={selectedWallet}*/}
        {/*          containerClassName="w-["*/}
        {/*        />*/}
        {/*      )}*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</div>*/}
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            {transactionsData?.data && transactionsData?.data.totalCount > 0 ? (
              <TransactionsTable
                data={(transactionsData?.data.transactions as Transaction[]) || []}
                onSortingChange={handlerSortingChange}
                sorting={sort}
              />
            ) : (
              <div className="flex h-full items-center justify-center py-2">
                <span className="text-white text-opacity-50">No Transactions yet</span>
              </div>
            )}
            {transactionsData?.data && transactionsData?.data.totalCount / LIMIT > 1 && (
              <Paginator
                currentPage={pageNumber + 1}
                itemsPerPage={LIMIT}
                onPageChange={onPageNumberChange}
                totalItems={transactionsData?.data.totalCount}
              />
            )}
          </>
        )}
      </div>
    </Modal>
  );
};

export default TransactionsModal;
